$(function () {

  $(document).on('click', e => {
    if ( !$('.js-feedback-dropdown-button').is(e.target) && $('.js-feedback-dropdown-button').has(e.target).length === 0 && !$('.js-feedback-dropdown-container').is(e.target) && $('.js-feedback-dropdown-container').has(e.target).length === 0 ) {
      $('.js-feedback-dropdown-container').fadeOut(300);
    }
  })

  $('.js-feedback-dropdown-button').on('click', function (e) {
    e.preventDefault();
    $('.js-feedback-dropdown-container').fadeToggle(300);
  })
})